// the Quickswap Default token list lives here
export const DEFAULT_TOKEN_LIST_URL =
  'https://unpkg.com/quickswap-default-token-list@1.2.26/build/quickswap-default.tokenlist.json';

export const DEFAULT_LIST_OF_LISTS: string[] = [DEFAULT_TOKEN_LIST_URL];
